// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Geolocation from "../Geolocation/index.js";
import * as Restaumatic_Analytics_Types_Event from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic_Environment from "../Restaumatic.Environment/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_OldStorage from "../Restaumatic.OldStorage/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic_Prelude_SpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Restaumatic_Services_Geocoding_Reverse from "../Restaumatic.Services.Geocoding.Reverse/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
import * as Restaumatic_Services_Storage_LocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Restaumatic_Site_Components_Address from "../Restaumatic.Site.Components.Address/index.js";
import * as Restaumatic_Site_Components_DeliveryAddress_Storage from "../Restaumatic.Site.Components.DeliveryAddress.Storage/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic_Site_UI from "../Restaumatic.Site.UI/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_FRP_Async from "../Specular.FRP.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Utils_Tracking from "../Utils.Tracking/index.js";
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var dynamic_ = /* #__PURE__ */ Specular_FRP_Replaceable.dynamic_(Specular_Dom_Builder.monadReplaceBuilder)(monadFRP);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var when = /* #__PURE__ */ Control_Applicative.when(Specular_Dom_Builder.applicativeBuilder);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var readStoredValue = /* #__PURE__ */ Restaumatic_OldStorage.readStoredValue(Foreign_Generic_Class.intDecode)()(Specular_Dom_Builder.monadReaderBuilder)(Specular_Dom_Builder.monadEffectBuilder);
var unless = /* #__PURE__ */ Control_Applicative.unless(Specular_Dom_Builder.applicativeBuilder);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var setJSONItem = /* #__PURE__ */ Restaumatic_Services_Storage.setJSONItem()(Foreign_Generic_Class.intEncode);
var map = /* #__PURE__ */ Data_Functor.map(Specular_Dom_Builder.functorBuilder);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var streetNumberIsSymbol = {
    reflectSymbol: function () {
        return "streetNumber";
    }
};
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode));
var streetIsSymbol = {
    reflectSymbol: function () {
        return "street";
    }
};
var postCodeIsSymbol = {
    reflectSymbol: function () {
        return "postCode";
    }
};
var cityIsSymbol = {
    reflectSymbol: function () {
        return "city";
    }
};
var readStoredValue1 = /* #__PURE__ */ Restaumatic_OldStorage.readStoredValue(/* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(streetNumberIsSymbol)(decodeWithOptionsOther)())(streetIsSymbol)(decodeWithOptionsOther)())(postCodeIsSymbol)(decodeWithOptionsOther)())(cityIsSymbol)(decodeWithOptionsOther)()))()(Specular_Dom_Builder.monadReaderBuilder)(Specular_Dom_Builder.monadEffectBuilder);
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var storeValue = /* #__PURE__ */ Restaumatic_OldStorage.storeValue(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(streetNumberIsSymbol)(encodeWithOptionsOther))(streetIsSymbol)(encodeWithOptionsOther))(postCodeIsSymbol)(encodeWithOptionsOther))(cityIsSymbol)(encodeWithOptionsOther)))()(Specular_Dom_Builder.monadReaderBuilder)(monadFRP);
var map2 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorEvent);
var asks = /* #__PURE__ */ Control_Monad_Reader_Class.asks(Specular_Dom_Builder.monadAskBuilder);
var asyncRequestMaybe = /* #__PURE__ */ Specular_FRP_Async.asyncRequestMaybe(Specular_Dom_Builder.monadEffectBuilder)(monadFRP);
var map3 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var map4 = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var map5 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder);
var apply1 = /* #__PURE__ */ Control_Apply.apply(Specular_Dom_Builder.applyBuilder);
var subscribeEvent_ = /* #__PURE__ */ Specular_FRP_Base.subscribeEvent_(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var trackEvent = /* #__PURE__ */ Utils_Tracking.trackEvent(Effect_Class.monadEffectEffect);
var performEvent = /* #__PURE__ */ Specular_FRP_Async.performEvent(monadFRP);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Specular_FRP_Base.functorEvent);
var liftWidget = /* #__PURE__ */ Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder);
var toStreetAddress = function (v) {
    return wrap({
        street: v.street,
        streetNumber: v.streetNumber,
        city: v.city
    });
};
var storageManagerVersion = 1;
var storageManagerKey = "client_storageFormatVersion";
var geocodingStatus = function (displayEmptyMessage) {
    return function (dresult) {
        var geocodingError = Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "m-alert", "m-alert--danger", "js-geocoding-errors" ]) ])(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery.geocoding_error)));
        return dynamic_(mapFlipped(dresult)(function (result) {
            if (result instanceof Specular_FRP_Async.NotRequested) {
                return when(displayEmptyMessage)(Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "alert", "alert-info", "u-mb0" ]) ])(discard(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("icon-info-sign"), Specular_Dom_Element.attr("aria-hidden")("true") ])(Restaumatic_Prelude_Specular.wempty))(function () {
                    return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery.enter_address));
                })));
            };
            if (result instanceof Specular_FRP_Async.Loading) {
                return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("js-geocoding-in-progress") ])(discard(Restaumatic_Site_UI.spinnerIcon)(function () {
                    return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery.geocoding));
                }));
            };
            if (result instanceof Specular_FRP_Async.Loaded && result.value0 instanceof Data_Either.Left) {
                return geocodingError;
            };
            if (result instanceof Specular_FRP_Async.Loaded && (result.value0 instanceof Data_Either.Right && result.value0.value0 instanceof Data_Maybe.Nothing)) {
                return geocodingError;
            };
            if (result instanceof Specular_FRP_Async.Loaded && (result.value0 instanceof Data_Either.Right && result.value0.value0 instanceof Data_Maybe.Just)) {
                return Restaumatic_Prelude_Specular.wempty;
            };
            throw new Error("Failed pattern match at Restaumatic.Site.Components.DeliveryAddress (line 155, column 5 - line 174, column 15): " + [ result.constructor.name ]);
        }));
    };
};
var deliveryAddressKey = "client_street_address";
var deliveryAddressWidget = function (config) {
    return bind(readStoredValue(storageManagerKey))(function (v) {
        return discard(unless(Data_Maybe.isJust(v))(liftEffect(setJSONItem(Restaumatic_Services_Storage_LocalStorageWithFallback.localStorageWithFallback)(storageManagerKey)(storageManagerVersion))))(function () {
            return bind(map(Data_Maybe.fromMaybe(Restaumatic_Site_Components_Address.emptyRawDeliveryAddress))(map(map1(Restaumatic_Site_Components_DeliveryAddress_Storage.fromStoredDeliveryAddress))(readStoredValue1(deliveryAddressKey))))(function (initialAddress) {
                return bind(Restaumatic_Site_Components_Address.addressWidget(config)(initialAddress))(function (v1) {
                    return discard(storeValue(deliveryAddressKey)(map2(Restaumatic_Site_Components_DeliveryAddress_Storage.toStoredDeliveryAddress)(Specular_FRP_Base.changed(v1.rawAddress))))(function () {
                        return bind(asks(function (v2) {
                            return v2.geocoding;
                        }))(function (v2) {
                            return bind(asyncRequestMaybe(map3(map1(map4(map5(function (v3) {
                                return v3.location;
                            }))))(map3(map1(function (deliveryAddress) {
                                return v2.geocodeAddress((unwrap(deliveryAddress)).country)(toStreetAddress(deliveryAddress));
                            }))(v1.validAddress))))(function (v3) {
                                var result = apply(map3(function (v4) {
                                    return function (v5) {
                                        if (v4 instanceof Data_Maybe.Just && (v5 instanceof Specular_FRP_Async.Loaded && (v5.value0 instanceof Data_Either.Right && v5.value0.value0 instanceof Data_Maybe.Just))) {
                                            return new Data_Maybe.Just({
                                                address: v4.value0,
                                                location: v5.value0.value0.value0
                                            });
                                        };
                                        return Data_Maybe.Nothing.value;
                                    };
                                })(v1.validAddress))(v3);
                                return pure({
                                    address: result,
                                    status: v3,
                                    addressWithoutLocation: v1.validAddress
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};
var autolocatingDeliveryAddressWidget = function (config) {
    var shouldNotShowLocateWidget = function (isApp) {
        return function (isMobileGeolocationEnabled) {
            return function (isInIframe) {
                return isApp && !isMobileGeolocationEnabled || isInIframe;
            };
        };
    };
    var extractStreetAddress = function (reverseGeocodeResponse) {
        return Specular_FRP_Base.filterMapEvent(identity)(map2((function () {
            var $132 = map1(function ($134) {
                return (function (v) {
                    return v.streetAddress;
                })(unwrap($134));
            });
            return function ($133) {
                return join($132(Data_Either.hush($133)));
            };
        })())(reverseGeocodeResponse));
    };
    return bind(newEvent)(function (v) {
        return bind(apply1(apply1(map(shouldNotShowLocateWidget)(liftEffect(Restaumatic_Environment.isMobileApp)))(liftEffect(Restaumatic_Environment.isInIframe)))(liftEffect(Restaumatic_Environment.mobileGeolocationEnabled)))(function (n) {
            return discard(unless(n)(Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "form-group", "m-form__group", "u-full-width" ]), Specular_Dom_Element.classUnlessD(config.visible)("hide") ])(Specular_Dom_Element.el("button")([ Specular_Dom_Element.attr("type")("button"), Specular_Dom_Element.class_("btn btn-link u-p0"), Restaumatic_Prelude_SpecularExtra.onClickPreventDefault_(v.fire) ])(discard(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.classes([ "icon-target", "u-font-size-120p" ]) ])(Restaumatic_Prelude_Specular.wempty))(function () {
                return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery_method.locate_me));
            })))))(function () {
                return discard(subscribeEvent_(Data_Function["const"](trackEvent(Restaumatic_Analytics_Types_Event.LocateMe.value)))(v.event))(function () {
                    return bind(performEvent(voidRight(Geolocation.getCurrentPosition(Geolocation.defaultOptions))(v.event)))(function (locationCoordinates) {
                        return bind(map(extractStreetAddress)(performEvent(map2(Restaumatic_Services_Geocoding_Reverse.reverseGeocode(config.restaurantId))(locationCoordinates))))(function (geocodeStreetAddress) {
                            return bind(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("m-delivery-address__container"), Specular_Dom_Element.classUnlessD(config.visible)("hide") ])(deliveryAddressWidget({
                                withAptInfo: config.withAptInfo,
                                country: config.country,
                                accountId: config.accountId,
                                restaurantId: config.restaurantId,
                                geocodingAddressE: geocodeStreetAddress
                            })))(function (addressWidget) {
                                return discard(liftWidget(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("m-delivery-address__status"), Specular_Dom_Element.classUnlessD(config.visible)("hide") ])(geocodingStatus(config.withEmptyMessage)(addressWidget.status))))(function () {
                                    return pure({
                                        address: addressWidget.address,
                                        addressWithoutLocation: addressWidget.addressWithoutLocation
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};
export {
    deliveryAddressWidget,
    autolocatingDeliveryAddressWidget,
    geocodingStatus
};
